/* eslint-disable react/require-default-props,react/destructuring-assignment */
/* eslint-disable react/no-access-state-in-setstate,no-nested-ternary,react/jsx-handler-names */
/* eslint-disable no-shadow,react/sort-comp  */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { autobind } from 'core-decorators';
import classNames from 'classnames';
import get from 'lodash/get';
import CSSModules from 'react-css-modules';
import Autolinker from 'autolinker';
import { debounce } from 'lodash';
import browserHistory from 'react-router/lib/browserHistory';

import {
  ACTIONS,
  COMMUNITY_COMMENT_MENU,
  COMMUNITY_COMMENTS,
} from '../../constants/strings';
import sanitizeHtml from '../../utils/sanitizeHtml';
import { actions as commentList } from '../../redux/communities/commentsList';
import Avatar from '../Avatar';
import Button from '../Button';
import IconMenu from '../common/IconMenu';
import ActionConfirmation from '../common/ActionConfirmation';
import Heading from './Heading';
import Replies from './Replies';
import Reply from './Reply';
import generateHtmlText from '../../utils/generateHtmlText';
import withPopoverMenu from '../../hocs/withPopoverMenu';
import { reportActions } from '../../redux/ui/popup';
import { PUBLIC_PROFILE } from '../../constants/routes';
import { ALLOW_SOCIAL_CHAT_CREATION } from '../../constants/chat';
import { IDS } from '../../constants/ids';
import styles from './index.styl';

const mapDispatchToProps = {
  updateComment: commentList.editCommentStatus,
  showCommentReport: reportActions.comment,
};

@connect(
  null,
  mapDispatchToProps,
)
@withPopoverMenu
@injectIntl
@CSSModules(styles, { allowMultiple: true })
export default class Comment extends Component {
  static propTypes = {
    id: PropTypes.number,
    content: PropTypes.string,
    author: PropTypes.shape({
      id: PropTypes.number,
      user: PropTypes.shape({
        id: PropTypes.number,
        avatar: PropTypes.objectOf(PropTypes.string),
        username: PropTypes.string,
      }),
      role: PropTypes.string,
    }),
    comments: PropTypes.array,
    createdAt: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
    ]),
    replyTo: PropTypes.string,
    onReply: PropTypes.func,
    getCommentDeleteHandler: PropTypes.func,
    getCommentEditHandler: PropTypes.func,
    updated: PropTypes.bool,
    deleted: PropTypes.bool,
    deletedBy: PropTypes.string,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func,
    }),
    parentId: PropTypes.number,
    onRequestConversation: PropTypes.func,
    loggedUserId: PropTypes.number,
    canComment: PropTypes.bool,
    isNewComment: PropTypes.bool,
    updateComment: PropTypes.func.isRequired,
    getMenuItems: PropTypes.func.isRequired,
    showCommentReport: PropTypes.func,
  };

  static defaultProps = {
    isNewComment: false,
  };

  state = {
    active: false,
    onDeleteRequested: false,
    editing: false,
    confirmOpened: false,
  };

  componentDidMount() {
    const { isNewComment } = this.props;
    if (isNewComment) {
      this.debouncedOnDispatch();
    }
  }

  componentDidUpdate(prevProps) {
    // duplicate logic for comments, for replies works componentDidMount
    const { isNewComment } = this.props;
    if (prevProps.isNewComment !== isNewComment && isNewComment) {
      this.debouncedOnDispatch();
    }
  }

  debouncedOnDispatch = debounce(() => {
    const { id, updateComment, parentId } = this.props;
    updateComment({ id, parentId, prop: { isNewComment: false } });
  }, 10000);

  @autobind
  toggleReplyForm() {
    this.setState({ active: !this.state.active });
  }

  @autobind
  addReply(content) {
    this.props.onReply(content);
    this.setState({ active: false });
  }

  @autobind
  onEdit(content, onEdit) {
    onEdit(content);
    this.setState({ editing: false });
  }

  @autobind
  onRequestDelete() {
    this.setState({
      onDeleteRequested: true,
      confirmOpened: true,
    });
  }

  @autobind
  closeConfirmPopup() {
    this.setState({
      confirmOpened: false,
      onDeleteRequested: false,
    });
  }

  @autobind
  onRequestEdit() {
    this.setState({ editing: true });
  }

  @autobind
  onRequestSendMessage() {
    const { onRequestConversation } = this.props;
    onRequestConversation(this.authorId);
  }

  @autobind
  onRequestReport() {
    const { showCommentReport, id } = this.props;
    showCommentReport(id);
  }

  get authorId() {
    const { author } = this.props;
    return get(author, 'user.id');
  }

  gotoProfile = () => browserHistory.push(`${PUBLIC_PROFILE}/${this.authorId}`);

  render() {
    const { active, onDeleteRequested, editing, confirmOpened } = this.state;
    const {
      id,
      content,
      author,
      comments,
      createdAt,
      replyTo,
      getCommentDeleteHandler,
      getCommentEditHandler,
      deleted,
      deletedBy,
      updated,
      parentId,
      intl,
      canComment,
      loggedUserId,
      isNewComment,
      getMenuItems,
      onRequestConversation,
    } = this.props;
    const { formatMessage } = intl;
    const isFirstLevelComment = comments;
    const hasReplies = comments && comments.length;
    const onDelete = getCommentDeleteHandler({
      id,
      author,
      parentId,
    });

    const onEdit = getCommentEditHandler({
      id,
      author,
      parentId,
    });

    const body =
      deleted && deletedBy === 'moderator'
        ? formatMessage(COMMUNITY_COMMENTS.commentWasDeletedByModerator)
        : deleted
        ? formatMessage(COMMUNITY_COMMENTS.commentWasDeleted)
        : generateHtmlText(content);

    const isLoggedUserComment = loggedUserId === this.authorId;

    const getMenuOptions = () => {
      let options = {
        editComment: onEdit && canComment && this.onRequestEdit,
        removeComment: onDelete && canComment && this.onRequestDelete,
        report: !isLoggedUserComment && this.onRequestReport,
      };
      if (ALLOW_SOCIAL_CHAT_CREATION) {
        const sendMessageMenuItem = {
          sendMessage: !isLoggedUserComment && this.onRequestSendMessage,
        };
        options = { ...options, ...sendMessageMenuItem };
      }
      return options;
    };

    const menu = !deleted && !editing ? getMenuItems(getMenuOptions()) : null;

    const alistName = get(author, 'user.aliasName');

    return (
      <div styleName={classNames('root', { danger: onDeleteRequested })}>
        <If condition={menu}>
          <IconMenu
            id={IDS.POST.REPLY_COMMENT_MENU_TRIGGER}
            position={{ horizontal: 'right', vertical: 'bottom' }}
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              transform: 'translate(-25%, -25%)',
            }}
            items={menu}
            allScreens
          />
        </If>
        <div styleName="image" className="pointer" onClick={this.gotoProfile}>
          <Avatar
            children={alistName}
            size={40}
            src={get(author, 'user.avatar.thumbMin')}
          />
        </div>
        <div styleName="content">
          <Heading
            userName={alistName}
            onTitleClick={this.gotoProfile}
            {...{ comments, createdAt, replyTo, updated, isNewComment }}
          />
          <Choose>
            <When condition={editing}>
              <Reply
                initialContent={content}
                onSubmit={content => this.onEdit(content, onEdit)}
              />
            </When>
            <Otherwise>
              <div
                styleName={classNames('body', { deleted })}
                dangerouslySetInnerHTML={{
                  __html: Autolinker.link(sanitizeHtml(body), {
                    className: 'clickable',
                  }),
                }}
              />
            </Otherwise>
          </Choose>
          <If condition={onDelete}>
            <ActionConfirmation
              intl={intl}
              onClose={this.closeConfirmPopup}
              onSubmit={onDelete}
              opened={confirmOpened}
              title={formatMessage(COMMUNITY_COMMENT_MENU.deleteComment)}
              body={formatMessage(COMMUNITY_COMMENT_MENU.confirmDeleteComment)}
              actionButtonText={formatMessage(
                COMMUNITY_COMMENT_MENU.deleteComment,
              )}
            />
          </If>

          <If condition={isFirstLevelComment}>
            <If condition={hasReplies}>
              <Replies
                list={comments}
                parentId={id}
                getCommentDeleteHandler={getCommentDeleteHandler}
                getCommentEditHandler={getCommentEditHandler}
                commentAuthor={alistName}
                onRequestConversation={onRequestConversation}
                canComment={canComment}
                loggedUserId={loggedUserId}
              />
            </If>

            <If condition={(!deleted || hasReplies) && !editing && canComment}>
              <div styleName="action">
                <Choose>
                  <When condition={active}>
                    <Reply onSubmit={this.addReply} />
                  </When>
                  <Otherwise>
                    <Button
                      id={IDS.POST.REPLY_COMMENT_BTN}
                      color="accent"
                      raised
                      type="button"
                      onClick={this.toggleReplyForm}
                    >
                      <FormattedMessage {...ACTIONS.post.reply} />
                    </Button>
                  </Otherwise>
                </Choose>
              </div>
            </If>
          </If>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Comment/index.jsx